import LoggerService,{formatTrace} from '../../../services/LoggerService';
import INITIAL_STATE from './INITIAL_STATE';
import REDUCER_ACTIONS from './ACTIONS';

const LOG = LoggerService.getInstance();

const reducer = (
  state: any,
  action: any
) => {
	if (action.type === REDUCER_ACTIONS.SET_PAGE) {
		const {page} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_PAGE',{page}));
		return {...state,page};
	}
	if (action.type === REDUCER_ACTIONS.SET_TYPE) {
		const {type} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_TYPE',{type}));
		return {...state,type};
	}
	if (action.type === REDUCER_ACTIONS.SET_NAME) {
		const {name} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_NAME',{name}));
		return {...state,name};
	}
	if (action.type === REDUCER_ACTIONS.SET_IDCUSTOMER) {
		const {id_customer} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_IDCUSTOMER',{id_customer}));
		return {...state,id_customer};
	}
	if (action.type === REDUCER_ACTIONS.SET_REFERENTIAL_TYPE) {
		const {referential_type} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_REFERENTIAL_TYPE',{referential_type}));
		return {...state,referential_type};
	}
	// return state;
	throw new Error(`No matching "${action.type}" action type`);
};

export {INITIAL_STATE};
export default reducer;
